import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4302ec8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "plus" }, null, -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "icon icon-c2c"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon icon-group" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Transfer = _resolveComponent("Transfer")!
  const _component_CreateGroup = _resolveComponent("CreateGroup")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["TUI-search", [_ctx.env.isH5 ? 'TUI-search-H5' : '']]),
    ref: "dialog"
  }, [
    _createElementVNode("header", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.toggleOptionalShow && _ctx.toggleOptionalShow(...args)))
    }, [
      _hoisted_1,
      (_ctx.env.isH5)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t('TUISearch.发起会话')), 1))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          (_ctx.env.isH5)
            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("h1", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showOpen('isC2C')))
          }, _toDisplayString(_ctx.$t('TUISearch.发起单聊')), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_4,
          _createElementVNode("h1", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showOpen('isGroup')))
          }, _toDisplayString(_ctx.$t('TUISearch.发起群聊')), 1)
        ])
      ], 512), [
        [_vShow, _ctx.optionalShow]
      ])
    ]),
    _createVNode(_component_Dialog, {
      show: _ctx.open,
      isH5: _ctx.env.isH5,
      isHeaderShow: false,
      isFooterShow: false,
      background: false,
      "onUpdate:show": _cache[3] || (_cache[3] = (e) => (_ctx.open = e))
    }, {
      default: _withCtx(() => [
        (_ctx.step === 1)
          ? (_openBlock(), _createBlock(_component_Transfer, {
              key: 0,
              isSearch: _ctx.needSearch,
              title: _ctx.showTitle,
              list: _ctx.searchUserList,
              isH5: _ctx.env.isH5,
              isRadio: _ctx.createConversationType === 'isC2C',
              onSearch: _ctx.handleSearch,
              onSubmit: _ctx.submit,
              onCancel: _ctx.toggleOpen
            }, null, 8, ["isSearch", "title", "list", "isH5", "isRadio", "onSearch", "onSubmit", "onCancel"]))
          : (_openBlock(), _createBlock(_component_CreateGroup, {
              key: 1,
              onSubmit: _ctx.create,
              onCancel: _ctx.toggleOpen,
              isH5: _ctx.env.isH5
            }, null, 8, ["onSubmit", "onCancel", "isH5"]))
      ]),
      _: 1
    }, 8, ["show", "isH5"])
  ], 2))
}